import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import RestaurantMenuIcon from "@mui/icons-material/RestaurantMenu";
import SettingsIcon from "@mui/icons-material/Settings";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import RouteIcon from "@mui/icons-material/Route";
import IntegrationInstructionsIcon from "@mui/icons-material/IntegrationInstructions";
import ReceiptIcon from "@mui/icons-material/Receipt";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

export const steps = [
  {
    label: "Bem-vindo",
    icon: RocketLaunchIcon,
  },
  {
    label: "Cardápio",
    icon: RestaurantMenuIcon,
  },
  {
    label: "Operação",
    icon: SettingsIcon,
  },
  {
    label: "Entregas",
    icon: LocalShippingIcon,
  },
  {
    label: "Rotas",
    icon: RouteIcon,
    requiresManager: true,
  },
  {
    label: "Integrações",
    icon: IntegrationInstructionsIcon,
  },
  {
    label: "Fiscal",
    icon: ReceiptIcon,
  },
  {
    label: "Concluir",
    icon: CheckCircleIcon,
  },
];

export const stepContent = {
  welcome: {
    title: "Bem-vindo ao Slapie!",
    subtitle: "Parabéns por completar a configuração inicial",
    description:
      "Sua Central de Entrega e Loja já estão configuradas. Agora vamos te guiar pelos recursos adicionais que vão transformar seu delivery.",
  },
  menuProducts: {
    title: "Monte Seu Cardápio Digital",
    subtitle: "Crie e organize seu catálogo de produtos",
    features: [
      {
        title: "Cadastro de Produtos",
        description: "Adicione produtos com fotos, descrições e preços",
      },
      {
        title: "Informações Fiscais",
        description: "Configure NCM, impostos e dados fiscais por produto",
      },
      {
        title: "Categorias",
        description: "Organize seu cardápio em categorias intuitivas",
      },
      {
        title: "Disponibilidade",
        description: "Controle quais produtos estão disponíveis para venda",
      },
    ],
    ctaLabel: "Ir para Produtos",
    ctaRoute: "/products",
  },
  operations: {
    title: "Configure Sua Operação",
    subtitle: "Automatize e otimize seu fluxo de trabalho",
    features: [
      {
        title: "Usuários e Equipe",
        description: "Crie acessos para operadores com permissões específicas",
      },
      {
        title: "Impressão Automática",
        description: "Configure impressão automática de pedidos recebidos",
      },
      {
        title: "Aceitação Automática",
        description:
          "Aceite pedidos mesmo offline - não perca vendas por falta de internet",
      },
      {
        title: "Equipamentos",
        description: "Registre impressoras e maquininhas de cartão",
      },
      {
        title: "Preferências de Caixa",
        description: "Configure tipos de caixa e métodos de pagamento",
      },
    ],
    ctaLabel: "Configurar Operação",
    ctaRoute: "/delivery-center",
  },
  deliveryTeam: {
    title: "Gestão de Entregas",
    subtitle: "Configure sua equipe e zonas de entrega",
    features: [
      {
        title: "Time de Entregadores",
        description: "Cadastre e gerencie sua equipe de delivery",
      },
      {
        title: "Raios de Entrega",
        description: "Defina zonas com taxas e tempos personalizados",
      },
      {
        title: "Taxas por Distância",
        description:
          "Configure quanto o cliente paga e quanto o entregador recebe",
      },
      {
        title: "Valor Mínimo",
        description: "Estabeleça pedido mínimo por zona de entrega",
      },
    ],
    ctaLabel: "Configurar Entregas",
    ctaRoute: "/delivery-center",
  },
  routePricing: {
    title: "Entenda o Preço de Rotas",
    subtitle: "Como funciona a cobrança em entregas com múltiplos pedidos",
    explanation:
      "Quando um entregador sai para uma rota com vários pedidos, o sistema otimiza os ganhos:",
    keyPoint:
      "O pedido mais distante paga a taxa integral. Os demais pedidos na mesma rota pagam o valor configurado por você.",
  },
  integrations: {
    title: "Integrações Poderosas",
    subtitle: "Conecte-se com as principais plataformas",
    platforms: [
      {
        name: "iFood Chat",
        description:
          "Gerencie até 10 lojas no chat iFood integrado ao Slapie e converse com clientes direto no Slapie",
        features: ["Conversas Integradas", "Até 10 Lojas"],
      },
      {
        name: "Logística Terceirizada",
        description: "Use Uber Direct e Entrega Fácil quando precisar",
        features: ["Uber Direct", "Entrega Fácil"],
      },
      {
        name: "Códigos de Confirmação",
        description:
          "Configure quando a confirmação de entrega via código ifood será necessária",
        features: ["Por Ranking", "Personalizável"],
      },
    ],
    ctaLabel: "Ver Integrações",
    ctaRoute: "/delivery-center",
  },
  fiscal: {
    title: "Módulo Fiscal e Financeiro",
    subtitle: "Configure emissão de notas e impostos",
    features: [
      {
        title: "Dados Fiscais",
        description: "Configure CNPJ e informações da empresa",
      },
      {
        title: "Emissão de Cupons",
        description: "Escolha emitir por loja ou por operação",
      },
      {
        title: "Métodos de Pagamento",
        description: "PIX, dinheiro, cartões de crédito e débito",
      },
      {
        title: "Impostos",
        description: "Configure ICMS, ISS, PIS e COFINS",
      },
    ],
    ctaLabel: "Configurar Fiscal",
    ctaRoute: "/delivery-center",
  },
  final: {
    title: "Pronto para Começar!",
    subtitle: "Você está pronto para transformar seu delivery",
    message:
      "Todas essas configurações estão disponíveis a qualquer momento na Central de Entrega. Comece a vender agora e configure conforme sua necessidade.",
    primaryCta: "Começar a Usar o Slapie",
    secondaryCta: "Ver Configurações",
    secondaryRoute: "/delivery-center",
  },
};
